module.exports = __webpack_public_path__ + "static/media/icon-shower-private.0ae34c93.svg";